//******* **********//
export const STORE_MY_BOOK_DATA = "STORE_MY_BOOK_DATA";
export const STORE_MENU_COLLAPSE = "STORE_MENU_COLLAPSE";
export const STORE_FULL_ENGAGEMENT_OPEN = "STORE_FULL_ENGAGEMENT_OPEN";